import type { FrontendWidget } from '../types';
import { SchoolDetailsComponent } from './SchoolDetailsComponent';
import { SchoolDetailsComponentB } from './SchoolDetailsComponentB';
import { SchoolDetailsComponentC } from './SchoolDetailsComponentC';
import type { SchoolDetailsConfig, SchoolDetailsResolved } from './types';

export const schoolDetailsWidget: FrontendWidget<
  SchoolDetailsConfig,
  SchoolDetailsResolved
> = {
  componentType: 'widgets.school-details',
  displayName: 'School Details',
  ComponentA: SchoolDetailsComponent,
  ComponentB: SchoolDetailsComponentB,
  ComponentC: SchoolDetailsComponentC,
  // No resolveSync — lookup widget. `SchoolDetailsResolver` adds the
  // Standort's reviews for the LocalBusiness JSON-LD (SH-468). Everything
  // else it shows comes from the render context, so without resolved data it
  // renders from its config and only the rating is missing.
  resolveFallback: (config) => config,
};
